import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedLayout = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />; // Token yoksa login sayfasına yönlendir
  }
  return <Outlet />; // Token varsa çocuk bileşenleri (rotaları) render et
};

export default ProtectedLayout;